import type { ComponentProps, HTMLAttributes } from 'react';

import { IconSystem } from '#icons/IconSystem';
import type { ModuleType } from '#types/global';

type Props = {
	moduleType: ModuleType | null | string;
	size?: ComponentProps<typeof IconSystem>['size'];
} & HTMLAttributes<SVGElement>;

export function ModuleIcon({ moduleType, ...rest }: Props) {
	switch (moduleType) {
		case 'AUDIO':
			return <IconSystem icon="headphones" variant="filled" title="Artikel mit Audio-Inhalten" {...rest} />;

		case 'GALLERY':
			return <IconSystem icon="image-gallery" variant="filled" title="Artikel mit Bildergallerie" {...rest} />;

		case 'LIVESTREAM':
			return <IconSystem icon="livestream" variant="filled" title="Artikel mit Live-Inhalten" {...rest} />;

		case 'VIDEO':
			return <IconSystem icon="video" variant="filled" title="Artikel mit Video-Inhalten" {...rest} />;

		case 'TEXT':
			return <IconSystem icon="content-text" variant="filled" title="Artikel mit Text-Inhalten" {...rest} />;

		case 'IMAGE':
			return <IconSystem icon="image" variant="filled" title="Artikel mit Bild-Inhalten" {...rest} />;

		default:
			return null;
	}
}
